import React, { useEffect } from "react";
import styles from "./Alert.module.css";
import { Alert as AlertError } from "@justworkshr/milo-components";

interface IAlertInputProps {
  message?: string;
  allowAutoScroll?: boolean;
}

const Alert = ({ ...props }: IAlertInputProps): JSX.Element => {
  const { message, allowAutoScroll = true } = props;

  useEffect(() => {
    if (allowAutoScroll) {
      window.scrollTo(0, document.body.scrollHeight);
    }
  }, [allowAutoScroll]);

  return (
    <div className={styles.container}>
      <AlertError color="warning" visible={true}>
        {message ||
          "Sorry, there was a network error. Please try submitting the application again."}
      </AlertError>
    </div>
  );
};

export default Alert;
